/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing components that can dynamically render components.
 * @preferred
 * @module AviComponentRenderingModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
} from '@angular/core';

import { SharedModule } from 'ng/shared/shared.module';
import { AviFieldsetModule } from 'ng/modules/avi-forms/modules/avi-fieldset/avi-fieldset.module';

import {
    AviComponentAdderComponent,
    AviComponentOutletComponent,
} from './components';

@NgModule({
    declarations: [
        AviComponentAdderComponent,
        AviComponentOutletComponent,
    ],
    exports: [
        AviComponentAdderComponent,
        AviComponentOutletComponent,
    ],
    imports: [
        AviFieldsetModule,
        SharedModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AviComponentRenderingModule {}
